<div id="page-container">
  <div id="content-wrap">
    <headband></headband>
    <div class="header">
      <div class="header-container-sub align-items-start" style="position: relative; justify-content: center;">
        <div class="arrow-container pointer" style="margin-right: 10px; position: absolute; left: 0;"
          (click)="navigateArrow()">
          <img class="arrow" src="assets/arrow-left.svg">
          <p class="dark-blue text-sm" style="margin: 0;">Retour</p>
        </div>
        <h1 class="dark-blue text-xl no-margin"><img src="assets/progress-icon.svg" height="17px" width="17px"
            class="icon-inline" style="margin-right: 10px;">AUDIT D'INTÉGRITÉ DU SCRUTIN</h1>
      </div>
    </div>

    <div class="title-container">
      <h1 class="no-margin white text-lg" style="margin-bottom: 10px;">"{{title}}"</h1>
      <div class="flex flex-row align-items-center gap-10">
        <img src="assets/calendar-white.svg" height="17px" width="17px" class="icon-inline">
        <p class="no-margin white text-md">
          <span class="bold">Période du scrutin : </span>du {{startDate}} au {{endDate}}
        </p>
      </div>

    </div>

    <app-poll-audit-status *ngIf="audits != null" [status]="audits[0].integrity" [assessors]="2" [inactiveAssessors]="1"></app-poll-audit-status>


    <app-audit-hash *ngIf="audits != null" [auditComparisons]="auditComparisons"  (startAuditEvent)="startAudit()"
                    [auditSuccess]="auditSucceeded" [lastAudit]="audits[0]"  (reportDownload)="downloadAuditDetails()"></app-audit-hash>

    <app-audit-history [audits]="audits" (startAuditEvent)="startAudit()"
      [auditSuccess]="auditSucceeded" (reportDownload)="downloadHistory()"></app-audit-history>

    <app-audit-log *ngIf="audits != null" [auditEvents]="auditEvents"
                    [auditSuccess]="auditSucceeded" (reportDownload)="downloadLogs()"></app-audit-log>

    <!-- <div class="grid-col-3 poll-container">

      <div id="status" style="min-height: 50px; border: 1px solid #ff0000; border-radius: 8px;">
        <div class="flex flex-row gap-10 align-items-center content-center h-full">
          <img src="assets/calendar-crossed.svg" class="icon-inline">
          <div class="flex flex-column">
            <p class="no-margin grey text-md">Statut du scrutin</p>
            <p class="no-margin dark-blue text-lg bold">PROGRAMMÉ</p>
          </div>
        </div>
      </div>

      <div id="assessor" style="min-height: 50px; border: 1px solid #ff0000; border-radius: 8px;"
        class="flex content-center">
        <div class="flex flex-column align-items-center h-full content-center align-items-start">
          <div class="flex flex-row gap-10 align-items-center content-center">
            <img width="18px" id="silhouette" src="assets/silhouette_icon_black.svg">
            <p class="no-margin dark-blue text-md">Assesseurs <span class="bold">2/3</span></p>
          </div>
          <p-progressBar [value]="((3 - 1) / 3) * 100" [showValue]="false"></p-progressBar>
        </div>

      </div>

      <div id="download" style="min-height: 50px; border: 1px solid #ff0000; border-radius: 8px;">
        <div class="download-button content-center align-items-center flex flex-row h-full">
          <img src="assets/certificate-dl.svg" class="mr-10">
          <span class="download-text link-text">Fichier de votants</span>
        </div>
      </div>

    </div> -->

  </div>
</div>
